import React, {useCallback, useEffect, useState} from "react";
import Box from "@mui/material/Box";
import {findNotesByCandidateId, editNotes, deleteNotes} from "../../../utilities/HrAPI";
import keycloak from "../../../Keycloak";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import {TextField} from "@mui/material";
import Grid from "@mui/material/Grid";
import TablePagination from "@mui/material/TablePagination";
import Typography from '@mui/material/Typography';
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import EditIcon from '@mui/icons-material/Edit';
import TableCell from "@mui/material/TableCell";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import IconButton from '@mui/material/IconButton';
import TableBody from "@mui/material/TableBody";
import Modal from "@mui/material/Modal";
import {toast} from "react-toastify";
import Enums from "../../General/Enums";

const modalStyle = {position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: 'auto',
    bgcolor: 'background.paper',
    boxShadow: -100,
    p: 2}

export default function Notes({candidateId}) {
    const [notes, setNotes] = useState([{
        id: 0,
        note: "",
        candidateId: 0,
        date: "",
    }])
    const [curNotes, setCurNotes] = useState({
        id: 0,
        note: "",
        candidateId: 0,
        date: "",
    })
    const [showModal, setShowModal] = useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [showDeleteModal, setShowDeleteModal] = useState(false);


    const style = {
        "& label.Mui-focused": {
            color: "#FF6600",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#FF6600",
            },
        },
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const callNotesById = useCallback(() => {
            findNotesByCandidateId(candidateId, keycloak.token)
                .then((notes) => {
                    const formattedDate = new Date().toLocaleString('en-ZA', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                    });

                    const fetchedNotes = notes.map((note) => ({
                            id: note.id,
                            note: note.note,
                            candidateId: note.candidateId,
                            date: formattedDate,
                        }));
                    setNotes(fetchedNotes);
                })
                .catch((error) => {
                    console.error("Error fetching notes:", error);
                });
    }, [candidateId, setNotes])


    useEffect(() => {
           callNotesById();
        const interval = setInterval(() => {
            callNotesById();
        }, 5000);

        return () => clearInterval(interval);
    }, [callNotesById]);

    const closeModal = () => {
        setShowModal(false);
    }

    const openModal = (notes) => {
        setShowModal(true);
        setCurNotes(notes)
    }

    const showSaveSuccess = (string) => {
        toast.success(string, {
            position: toast.POSITION.TOP_LEFT,
            style: {
                backgroundColor: "#49c96d",
                width: "650px",
                color: "#FFFFFF",
                left: "500px",
                theme: "colored",
            }
        });
    };


    const editNote = (editedNote) => {
        const formattedDate = new Date().toLocaleString('en-ZA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });

        editedNote.date = new Date();

        editNotes(editedNote.id, editedNote, keycloak.token)
            .then(() => {
                showSaveSuccess("Note edited successfully")
                const updatedNotes = notes.map(note => {
                    if (note.id === editedNote.id) {
                        editedNote.date = formattedDate;
                        return editedNote;
                    }
                    return note;
                });
                setNotes(updatedNotes);
            })
            .catch((e) => {console.log(e)})
        setShowModal(false);
    }

    const handleChange = (e) => {
        let {value} = e.target;
        setCurNotes((prevNotes) => ({
            ...prevNotes,
            note: value,
        }));
    }

    const openDeleteModal = (note) => {
        setShowDeleteModal(true);
        setCurNotes(note)
    }

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
    }

    const handleDelete = () => {
        deleteNotes(curNotes.id, keycloak.token)
            .then(() => {
                closeDeleteModal()
            })
        setNotes(notes.filter(item => item.id !== curNotes.id));
    }


    return (
        <React.Fragment>
            <Modal data-testid={"editNotesModal"}
                   open={showModal}
                   aria-labelledby="modal-modal-title"
                   aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <Typography id="modal-modal-title" variant="h4" component="h2">
                        Edit Note
                    </Typography>
                    <Grid container direction={"row"} alignItems={"flex-end"} padding={2} spacing={2}>
                        <Grid item xs={12}>
                            <TextField data-testid={"notes-textField"}
                                       multiline={true}
                                       rows={8}
                                       value={curNotes?.note}
                                       onChange={(e) => {handleChange(e)}}
                                       style={{width: "100%"}}
                                       sx={style}/>
                        </Grid>
                        <Grid item xs={10}>
                            <Button variant="outlined" data-testid={"cancel"} onClick={closeModal} style={{
                                float: 'right',
                                width: '89px',
                                height: '40px',
                                fontFamily: 'Poppins',
                                color: '#FF6600',
                                borderColor: '#FF6600'
                            }}>Cancel</Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={() => {editNote(curNotes)}} data-testid={"save"} style={{
                                float: "right",
                                backgroundColor: '#FF6600',
                                width: '89px',
                                height: '40px',
                                fontFamily: 'Poppins',
                                color: '#FFFFFF',
                                marginLeft: 'auto',
                            }}>Save</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
            <Modal open={showDeleteModal}
                   data-testid={"delete-notes-modal"}>
                <Box sx={Enums.modalStyle}>
                    <h3>
                        Delete Note
                    </h3>
                    <Grid container direction={"row"} alignItems={"flex-end"} padding={2} spacing={2}>
                        <Grid item xs={12}>
                            <body-4>
                                Are you sure you want to delete this note?
                            </body-4>
                        </Grid>
                        <Grid item xs={10}>
                            <Button variant="outlined" data-testid={"cancel-delete"} onClick={closeDeleteModal} style={{
                                float: 'right',
                                width: '89px',
                                height: '40px',
                                fontFamily: 'Poppins',
                                color: '#FF6600',
                                borderColor: '#FF6600'
                            }}>Cancel</Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={handleDelete} data-testid={"delete-note"} style={{
                                float: "right",
                                backgroundColor: '#FF6600',
                                width: '89px',
                                height: '40px',
                                fontFamily: 'Poppins',
                                color: '#FFFFFF',
                                marginLeft: 'auto',
                            }}>Delete</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
            <Box data-testid={"notes"}>
                <Table sx={{width: '100%'}} data-testid={"notesTable"}>
                    <TableBody>
                        {(rowsPerPage > 0
                                ? notes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : notes
                        ).map((note, index) => (
                            <React.Fragment>
                                    <TableRow key={index}>
                                        <TableCell colSpan={2} sx={{borderBottom: "none"}}>
                                            <Card elevation={0} className={"p-3 bg-secondary-1 justify-content-between m-0"}>
                                                <CardContent >
                                                    <Grid container direnction={"row"} >
                                                        <Grid item xs={11}>
                                                            <Typography variant={"h5"}>{note.date.toString()}</Typography>
                                                        </Grid>
                                                        <Grid item xs={0.5}>
                                                            <IconButton onClick={() => {openModal(notes[index])}} data-testid={`editButton${index}`}>
                                                                <EditIcon/>
                                                            </IconButton>
                                                        </Grid>
                                                        <Grid item xs={0.5}>
                                                            <IconButton onClick={() => {openDeleteModal(notes[index])}} data-testid={`deleteButton${index}`}>
                                                                <DeleteOutlineIcon/>
                                                            </IconButton>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField multiline={true}
                                                                       rows={note.note.split("\n").length}
                                                                       value={note.note}
                                                                       sx={{
                                                                           '& .MuiOutlinedInput-root': {
                                                                               '& fieldset': {
                                                                                   border: 'none',
                                                                               },
                                                                           },
                                                                       }}
                                                                       style={{pointerEvents: "none", width: "100%"}}>
                                                            </TextField>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </TableCell>
                                    </TableRow>


                            </React.Fragment>
                        ))}
                        <TablePagination
                            data-testid={"tablePagination"}
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={notes.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableBody>
                </Table>
            </Box>
        </React.Fragment>
    );
}